var _defs, _g, _g2, _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500px",
    height: "500px",
    viewBox: "0 0 200 200",
    style: {
      overflow: "hidden!important"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1007"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2907",
    cx: 100,
    cy: 114,
    r: 41,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2908",
    stopOpacity: 0.5,
    stopColor: "#ffe4d6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2909",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2911",
    cx: 100,
    cy: 54,
    r: 37,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2912",
    stopOpacity: 0.5,
    stopColor: "#ffe4d6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2913",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3224",
    cx: -568.659,
    cy: -521.042,
    r: 59.751,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 141.2814 119.9893)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3225",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3226",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3228",
    cx: -582.838,
    cy: -519.099,
    r: 59.745,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 131.1134 135.9855)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3229",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3230",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3234",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3235",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3236",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3238",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3239",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3240",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3242",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3243",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3244",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3247",
    cx: -568.654,
    cy: -521.042,
    r: 59.752,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 193.2804 119.9894)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3248",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3249",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient3251",
    cx: -582.833,
    cy: -519.102,
    r: 59.747,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 183.1126 135.9856)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3252",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3253",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3257",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3258",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3259",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3261",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3262",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3263",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3265",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3266",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3267",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4071",
    x1: 100,
    y1: 171,
    x2: 100,
    y2: 131,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-chinshadow-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4072",
    stopOpacity: 0.8,
    stopColor: "#e1ac8f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4073",
    stopOpacity: 1,
    stopColor: "#c27b55",
    offset: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4151",
    x1: 100,
    y1: 142,
    x2: 100,
    y2: 139,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-mouth-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4152",
    stopOpacity: 1,
    stopColor: "#e8b9a0",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4153",
    stopOpacity: 1,
    stopColor: "#e1ac8f",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4161",
    cx: 125.903,
    cy: 85.096,
    r: 13.25,
    gradientTransform: "matrix(-1.0996 0.0423 0.0635 0.9207 206.5488 0.5932)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4162",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4163",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4164",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4165",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4166",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4167",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4169",
    cx: 125.541,
    cy: 85.113,
    r: 13.249,
    gradientTransform: "matrix(1.0996 0.0423 -0.0635 0.9207 -6.5488 0.5932)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4170",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4171",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4172",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4173",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4174",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4175",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4177",
    cx: 125.903,
    cy: 85.096,
    r: 13.25,
    gradientTransform: "matrix(-1.0996 0.0423 0.0635 0.9207 206.5488 0.5932)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4178",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4179",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4180",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4181",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4182",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4183",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4187",
    cx: 123.371,
    cy: 81.442,
    fx: 136.805,
    fy: 80.36,
    r: 17.038,
    gradientTransform: "matrix(0.9884 0.1367 0.1336 -0.7354 -56.0677 125.3)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4188",
    stopOpacity: 1,
    stopColor: "#e1ac8f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4189",
    stopOpacity: 0.3,
    stopColor: "#e1ac8f",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4190",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4192",
    cx: 78.965,
    cy: 81.143,
    r: 26.237,
    gradientTransform: "matrix(0.7183 -0.06 0.0803 0.6143 8.7915 49.2595)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4193",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4194",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4198",
    cx: 125.541,
    cy: 85.113,
    r: 13.249,
    gradientTransform: "matrix(1.0996 0.0423 -0.0635 0.9207 -6.5488 0.5932)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4199",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4200",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4201",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4202",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4203",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4204",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4208",
    cx: 122.972,
    cy: 81.425,
    fx: 136.406,
    fy: 80.344,
    r: 17.037,
    gradientTransform: "matrix(-0.9884 0.1367 -0.1336 -0.7354 255.271 125.3424)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4209",
    stopOpacity: 1,
    stopColor: "#e1ac8f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4210",
    stopOpacity: 0.3,
    stopColor: "#e1ac8f",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4211",
    stopOpacity: 0,
    stopColor: "#f0c7b1",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4213",
    cx: 79.515,
    cy: 81.186,
    r: 26.237,
    gradientTransform: "matrix(-0.7183 -0.06 -0.0803 0.6143 191.2076 49.2665)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4214",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4215",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-wrapper"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-backs-single"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap",
    transform: "matrix(0.8999997000000001,0,0,0.8999997000000001,9.971623962328522,11.584246054437486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3680",
    d: "M100.5,100.5h-1v-1h1V100.5z",
    fill: "#b84131",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2914",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2915",
    d: "M159.156 184.058c24.342 3.542 34.586 8.708 37.794 50.721H200c0-12.5-0.877-26.992-4.583-35 -2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-18.242-12.069-21.643-16.35 3.36 4.704 12.791 15.605 21.054 18.46C150.188 182.61 153.48 183.232 159.156 184.058zM53.766 181.244c8.263-2.854 17.693-13.756 21.054-18.46 -3.4 4.28-16.114 15.054-21.643 16.35 -6.896 1.615-25.494 4.619-33.733 7.022 -6.665 1.942-12.664 8.876-14.86 13.622 -3.706 8.008-4.583 22.5-4.583 35h3.05c3.188-41.744 13.475-47.183 37.794-50.721C46.52 183.232 49.813 182.61 53.766 181.244z",
    fill: "#ffe4d6",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2916",
    d: "M95.646 197.62c0 0-5.074-1.609-7.083-2.379 -10.449-4.009-44.395-6.607-44.395-6.607s35.754 1.419 43.644 2.779c-0.458-4.767-3.017-20.004-3.017-20.004s5.149 16.815 6.409 21.057C91.878 194.734 95.646 197.62 95.646 197.62zM106.445 196.278c-0.089 0.073-0.191 0.168-0.302 0.268C106.256 196.461 106.358 196.372 106.445 196.278zM95.646 197.62c0 0 2.893 2.992 4.347 3.03 1.91 0.051 4.828-2.899 6.151-4.104 -1.265 0.957-4.159 1.391-5.31 1.436C99.504 198.033 95.646 197.62 95.646 197.62zM116.664 190.101c-1.545 0.248-4.386 0.789-4.386 0.789l2.287-14.89c-0.646 3.071-4.474 16.211-8.12 20.278 1.91-1.616 6.158-2.391 8.324-2.704 10.236-1.484 10.232-1.483 41.062-4.94C155.831 188.634 126.76 188.479 116.664 190.101z",
    fill: "#e1ac8f",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2917",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "none",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-chinshadow-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4070",
    d: "M100.021 171.866c8.183 0 16.871-4.943 24.199-10.675 -0.001-6.702 1.451-19.105 2.652-28.205 -15.382-2.247-38.406-2.279-53.766-0.152 1.184 8.96 2.625 21.206 2.671 28.02C83.119 166.767 91.822 171.866 100.021 171.866z",
    fill: "url(#SvgjsLinearGradient4071)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-clothes-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4001",
    d: "M-3.682 236.192c-2.914-24.293 8.022-47.09 34.496-54.611 7.77-2.208 5.691-3.341 6.867-3.41 -0.039-0.211-0.045-0.2-0.045-0.63h-0.036c0.087-8.03 9.028-6.453 11.587-6.984 10.121-2.158 13.558-12.786 25.115-9.985 0.284 2.437 0.075 5.248-1.371 15.663 10.899 23.466 22.722 21.437 26.925 34.571 3.815-11.746 17.339-13.617 27.306-34.576 -0.655-5.884-2.083-11.033-1.482-15.935l0.057-0.042c7.744-2.583 11.127 0.874 14.21 3.854 9.397 9.083 14.382 3.325 19.085 7.457 1.871 1.659 2.547 3.997 2.547 6.518 21.412 3.11 45.974 9.898 41.089 57.481l0.096 0.104C181.094 235.667 57.546 241.095-3.682 236.192z",
    fill: "#39557e",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4002",
    d: "M100.268 209.685c4.229-10.638 16.946-13.132 26.543-32.755 0.098-0.108 0.347-0.591 0.656-1.237 -0.164-1.826-0.372-3.747-1.213-5.757 -0.522-3.35-0.939-6.489-0.587-9.535 1.974 0.578 3.842 1.262 5.12 2.66 1.882 2.052 0.455 5.609-1.346 9.042C126.063 186.844 117.594 197.493 100.268 209.685zM169.282 198.859c2.938 10.376 4.895 26.928 2.544 37.445 1.962-0.045 2.686-0.097 4.506-0.138C177.146 225.12 175.154 207.48 169.282 198.859zM137.604 200.735c-12.805 7.48-25.687 10.358-37.321 20.291 -11.64-9.904-24.647-11.637-37.453-19.108 -5.87-2.36-14.874-10.699-20.377-16.572 17.313 26.284 29.706 18.823 57.434 36.538 27.736-17.715 40.205-11.692 57.516-37.974C151.9 189.782 143.476 198.39 137.604 200.735zM99.81 210.936c-4.238-10.644-16.459-14.383-26.056-34.006 -0.093-0.108-0.343-0.591-0.652-1.237 0.156-1.826-0.262-3.841 0.586-5.857 0.521-3.358 0.748-6.092 0.393-9.132 -1.969 0.574-3.025 0.959-4.303 2.357 -1.88 2.052-0.453 5.609 1.347 9.042C74.502 186.844 82.479 198.74 99.81 210.936zM27.163 197.688c-4.305 9.396-4.34 27.432-3.528 38.479 1.821 0.041 2.548 0.093 4.506 0.138C25.791 225.787 26.379 208.26 27.163 197.688zM99.888 212.964c16.389-4.909 33.813-13.894 48.305-35.847 -13.084 17.643-32.525 28.063-47.926 34.455 -15.89-5.762-34.915-17.221-46.006-32.635C67.257 200.226 83.508 208.055 99.888 212.964z",
    fill: "#27446f",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4003",
    d: "M202.762 235.667c-0.115 0-0.256 0.001-0.374 0.001 -0.427-48.615-27.497-50.574-42.48-53.725 -2.345 0-3.563-6.505-5.288-8.24 -1.467-1.475-12.769-1.475-16.348-11.169 0.583 0.513 1.131 1.052 1.674 1.573 9.397 9.083 14.382 3.325 19.085 7.457 1.871 1.659 2.547 3.997 2.547 6.518 21.412 3.11 45.974 9.898 41.089 57.481L202.762 235.667zM-3.968 236.84c0.114 0 0.255 0.001 0.376 0.001 4.759-38.632 16.029-50.811 43.543-55.364 3.451-1.313 1.634-3.81 3.362-5.544 1.467-1.468 9.627-1.5 20.924-13.389 -0.582 0.513-3.075 1.042-3.615 1.563 -9.398 9.083-16.485 6.51-19.088 7.457 -3.209 1.188-3.707 4.028-3.707 6.546 -21.414 3.111-44.161 14.974-41.702 58.626L-3.968 236.84z",
    fill: "#4e688d",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4004",
    d: "M161.69 177.978c0-9.858-9.265-7.895-13.529-8.812 -9.409-2.02-9.113-12.916-22.582-8.985 -0.574 4.657 0.516 8.738 1.473 15.997 -9.877 20.755-23.576 23.093-27.196 34.245 -3.957-12.38-16.045-11.134-26.81-34.171 1.498-10.838 1.648-13.354 1.36-15.774 -10.271-2.349-12.588 4.32-21.876 8.776 -5.637 2.642-7.229 0.263-12.067 2.633 -2.007 0.968-3.018 3.609-2.946 5.767 -0.013 0.01 0 0.01 0 0.01 0 0.139 0 0.267 0.023 0.396 -1.175 0.082 0.546 0.074-7.323 1.346 -25.363 4.1-36.61 25.534-34.005 56.906 11.89 0 1.011 4.382 183.147-0.077 8.456-0.214 22.799-0.447 23.402-0.447C208.321 189.265 184.836 181.568 161.69 177.978zM-3.624 236.057c2.579-36.004 8.018-50.026 41.046-57.329 17.978 29.839 39.98 25.499 62.232 42.189 -20.166-16.771-41.302-14.549-61.622-42.583 -0.228-2.354 1-4.943 3.535-5.959 1.796-0.702 3.72-0.498 5.6-0.488 7.087 0.054 12.546-5.502 17.793-9.578 2.499-1.67 6.22-1.752 9.2-1.292 0.231 3.874-1.262 9.721-1.762 13.845 -1.042-2.295-2.029-4.664-3.015-7.022 12.47 36.624 24.903 28.334 30.461 43.525 -1.177-0.327-21.014-7.468-36.822-23.188 -3.358-3.325-10.011-10.656-10.516-11.34 19.573 26.51 32.079 27.86 47.391 34.691 0 0.01 0.021 0.035 0.021 0.048 0.012 0.036 0.068 0.221 0.086 0.256 0.074-0.033 0.158-0.07 0.239-0.091 0.026-0.022 0.047-0.033 0.08-0.033 2.122-1.043 16.065-5.902 26.681-13.2 10.927-7.517 23.39-23.821 22.451-22.64 -18.253 18.573-21.075 22.785-49.212 35.67 -0.027 0-0.048-0.01-0.069-0.021 -0.022-0.131-0.064-0.257-0.107-0.387 0.011-0.062 0.032-0.121 0.054-0.178 4.948-13.579 19.476-8.33 31.51-45.554 -1.232 3.216-2.527 6.382-3.979 9.486 -0.457-5.455-2.042-9.756-1.865-14.247 2.084-0.693 7.742-1.022 9.308 0.542 6.529 5.586 7.059 9.677 17.696 9.677 3.411 0.02 7.871 0.45 8.375 6.708 -0.627 0.922-5.291 6.431-9.703 10.809 -15.438 15.368-29.249 15.664-50.619 32.007 0.521 0 1.605-1.131 2.029-1.418 16.712-11.864 28.719-11.677 44.085-24.249 7.082-5.785 13.897-15.044 14.63-16.222 0.022 0.013 0.059 0.013 0.079 0.013 28.198 4.853 42.321 15.462 40.764 57.069C76.043 234.783 58.884 238.145-3.624 236.057z",
    fill: "#0c2850",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-head",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2927",
    d: "M45.671 84.344c-1.485-2.462-6.327-9.199-10.031-8.254 -3.012 0.772-2.973 4.971-3.206 7.455 -0.34 3.644-0.464 9.992 0.525 12.568 0.951 2.473 3.96 7.252 5.828 9.075 2.299 2.235 5.97 9.358 6.422 10.097 0.711 1.168 2.137 2.84 4.325 2.708 3.071-0.185 5.724-3.087 5.965-4.485C56.8 105.918 49.536 90.75 45.671 84.344z",
    fill: "#f0c7b1",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2928",
    d: "M44.2 99.341c-0.143-0.563 0.007-1.513 0.154-2.429 0.133-0.835 0.258-1.624 0.182-2.182 -0.289-2.09-1.915-6.06-2.976-8.212 -1.223-2.476-3.199-5.595-5.679-6.399 -1.024-0.333-1.699 0.065-2.089 0.468 -0.288 0.296-0.353 0.645-0.259 0.687 0.095 0.041 0.307-0.248 0.617-0.519 0.254-0.222-0.508-0.04 0 0 -0.205 1.04-0.865 6.302-0.41 10.143 0.358 3.022 1.05 5.279 1.263 5.617 0.031 0.356 0.083 0.705 0.16 1.043 1.002 4.41 7.518 10.177 9.034 11.82 0.28 0.303 0.574 0.483 0.646 0.409s-0.101-0.373-0.379-0.678c-1.498-1.632-7.971-7.381-8.939-11.635 -1.027-4.514 3.912-11.207 4.699-12.623 0.401 0.665 0.742 1.303 1.004 1.835 0.207 0.417 0.434 0.906 0.67 1.435 -0.463 0.738-5.118 6.127-3.934 10.441 0.438 1.591 3.822 3.642 5.131 4.203 0.72 0.31 0.99 0.772 1.304 1.306 0.364 0.624 0.033 2.229 1.23 2.739 0.244 0.104 0.464 0.146 0.659 0.146 0.338 0 0.594-0.13 0.783-0.284 0.02 0.271 0.019 0.619 0.009 0.941 -0.012 0.418 0.047 0.609 0.148 0.617 0.103 0.009 0.21-0.174 0.223-0.587 0.017-0.51 0.014-1.141-0.077-1.444 -0.269-0.889-1.088-1.894-1.957-2.957C44.563 102.197 44.422 100.213 44.2 99.341zM34.969 95.432c-2.348-6.923 1.283-13.229 1.81-14.179 1.012 0.399 2.562 2.193 3.221 3.235C39.52 85.321 35.067 90.775 34.969 95.432zM45.772 106.464c-1.084-0.462-0.706-1.984-1.056-2.584 -0.318-0.542-0.646-1.102-1.479-1.46 -0.18-0.078-0.379-0.196-0.583-0.332 -2.682-6.075 0.293-8.73 1.039-9.273 0.229 0.742 0.399 1.423 0.476 1.97 0.068 0.5-0.059 1.298-0.181 2.068 -0.153 0.955-0.31 1.944-0.147 2.584 0.244 0.953 0.411 2.97 1.291 4.048 0.781 0.956 1.583 1.942 1.857 2.746C46.871 106.391 46.5 106.775 45.772 106.464z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2929",
    d: "M154.066 84.344c1.486-2.462 6.328-9.199 10.031-8.254 3.012 0.772 2.973 4.971 3.207 7.455 0.34 3.644 0.463 9.992-0.525 12.568 -0.951 2.473-3.961 7.252-5.828 9.075 -2.299 2.235-5.971 9.358-6.422 10.097 -0.711 1.168-2.137 2.84-4.326 2.708 -3.07-0.185-5.723-3.087-5.965-4.485C142.938 105.918 150.203 90.75 154.066 84.344z",
    fill: "#f0c7b1",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2930",
    d: "M154.322 103.243c-0.869 1.063-1.688 2.068-1.957 2.957 -0.092 0.304-0.094 0.935-0.078 1.444 0.014 0.413 0.121 0.596 0.225 0.587 0.102-0.008 0.16-0.199 0.148-0.617 -0.01-0.322-0.012-0.67 0.008-0.941 0.189 0.154 0.445 0.284 0.783 0.284 0.195 0 0.416-0.042 0.66-0.146 1.195-0.511 0.865-2.116 1.229-2.739 0.314-0.534 0.584-0.997 1.305-1.306 1.309-0.561 4.693-2.611 5.131-4.203 1.184-4.314-3.471-9.704-3.934-10.441 0.234-0.529 0.463-1.018 0.668-1.435 0.264-0.532 0.604-1.171 1.006-1.835 0.787 1.416 5.725 8.108 4.699 12.623 -0.969 4.254-7.441 10.003-8.939 11.635 -0.279 0.305-0.453 0.604-0.381 0.678 0.074 0.074 0.367-0.106 0.646-0.409 1.516-1.643 8.031-7.41 9.033-11.82 0.078-0.338 0.131-0.687 0.162-1.043 0.211-0.337 0.904-2.594 1.262-5.617 0.455-3.841-0.205-9.103-0.41-10.143 0.508-0.04-0.254-0.222 0 0 0.311 0.271 0.523 0.56 0.617 0.519 0.094-0.042 0.029-0.39-0.258-0.687 -0.391-0.403-1.066-0.801-2.09-0.468 -2.48 0.804-4.457 3.923-5.68 6.399 -1.061 2.152-2.686 6.122-2.975 8.212 -0.076 0.558 0.049 1.347 0.182 2.182 0.146 0.916 0.297 1.866 0.154 2.429C155.316 100.213 155.176 102.197 154.322 103.243zM159.738 84.488c0.66-1.042 2.209-2.835 3.221-3.235 0.527 0.95 4.158 7.256 1.811 14.179C164.672 90.775 160.219 85.321 159.738 84.488zM152.75 106.229c0.273-0.804 1.076-1.79 1.857-2.746 0.879-1.078 1.047-3.095 1.291-4.048 0.162-0.64 0.006-1.629-0.146-2.584 -0.123-0.77-0.25-1.568-0.182-2.068 0.076-0.547 0.246-1.228 0.475-1.97 0.746 0.543 3.721 3.199 1.039 9.273 -0.203 0.136-0.402 0.254-0.584 0.332 -0.832 0.358-1.16 0.918-1.479 1.46 -0.35 0.6 0.029 2.123-1.055 2.584C153.238 106.775 152.867 106.391 152.75 106.229z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-wrap",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4067",
    d: "M158.785 78.006l-0.005 0c-0.01 0.046-12.197 40.27-15.879 52.418 -0.715 2.358-1.931 4.551-3.556 6.386 -6.375 7.194-23.768 25.057-39.324 25.057 -15.849 0-33.591-19.045-39.708-26.214 -1.442-1.688-2.507-3.633-3.172-5.765 -3.607-11.551-16.126-51.648-16.137-51.694h-0.001c-1.298-4.992-1.994-10.231-2.002-15.634C38.949 28.536 66.155 0.92 99.773 0.867c33.621-0.053 60.913 27.476 60.964 61.499C160.746 67.769 160.068 73.01 158.785 78.006z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4068",
    d: "M132.168 10.26c14.31 11.135 23.671 29.457 23.699 50.208 0.009 5.404-0.615 10.645-1.796 15.641l-0.004 0c-0.009 0.046-11.223 40.27-14.608 52.417 -0.658 2.358-1.776 4.551-3.271 6.385 -5.865 7.195-21.866 25.059-36.178 25.059 -14.582 0-30.904-19.047-36.531-26.215 -1.327-1.689-2.306-3.633-2.918-5.764 -3.318-11.552-14.836-51.649-14.846-51.695h-0.001c-1.194-4.992-1.834-10.231-1.842-15.634 -0.029-20.827 9.348-39.239 23.713-50.412C50.392 21.159 38.967 40.508 39.001 62.56c0.008 5.403 0.704 10.643 2.002 15.634h0.001c0.01 0.046 12.53 40.143 16.137 51.694 0.666 2.132 1.73 4.076 3.172 5.765 6.116 7.169 23.858 26.214 39.708 26.214 15.557 0 32.949-17.862 39.324-25.057 1.625-1.835 2.841-4.027 3.556-6.386 3.682-12.148 15.869-52.372 15.879-52.418l0.005 0c1.283-4.997 1.961-10.237 1.952-15.641C160.704 40.389 149.297 21.135 132.168 10.26z",
    fill: "#e8b9a0",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4069",
    d: "M158.785 78.006l-0.005 0c-0.01 0.046-12.197 40.27-15.879 52.418 -0.715 2.358-1.931 4.551-3.556 6.386 -6.375 7.194-23.768 25.057-39.324 25.057 -15.849 0-33.591-19.045-39.708-26.214 -1.442-1.688-2.507-3.633-3.172-5.765 -3.607-11.551-16.126-51.648-16.137-51.694h-0.001c-1.298-4.992-1.994-10.231-2.002-15.634C38.949 28.536 66.155 0.92 99.773 0.867c33.621-0.053 60.913 27.476 60.964 61.499C160.746 67.769 160.068 73.01 158.785 78.006z",
    fill: "none",
    stroke: "#c27b55",
    strokeWidth: 1.5,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4150",
    d: "M100.2 142.947c-2.832 0.144-3.644-2.753-3.644-2.753s3.931 0.565 6.991-0.353C103.548 139.842 102.692 142.822 100.2 142.947z",
    fill: "url(#SvgjsLinearGradient4151)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4154",
    d: "M100.488 140.76c-1.984 0.1-3.765-0.077-3.877-0.089 -0.138-0.014-0.238-0.136-0.224-0.272 0.015-0.138 0.143-0.233 0.274-0.224 0.041 0.003 4.096 0.405 6.738-0.337 0.131-0.032 0.271 0.041 0.309 0.174s-0.04 0.27-0.173 0.308C102.601 140.582 101.517 140.708 100.488 140.76z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4155",
    d: "M82.5 130.299c0 0 12.532 1.486 16.718 1.499 4.553 0.012 19.282-1.499 19.282-1.499 -4.258 3.534-8.943 6.932-19.555 6.999C89.453 137.359 87.021 133.912 82.5 130.299z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4156",
    d: "M82.5 130.299c0 0 12.532 1.486 16.718 1.499 4.553 0.012 19.282-1.499 19.282-1.499 -4.258 3.534-8.943 6.932-19.555 6.999C89.453 137.359 87.021 133.912 82.5 130.299z",
    fill: "none",
    stroke: "#c27b55",
    strokeWidth: 0.75,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4160",
    d: "M76.732 78.383c4.587 0.679 7.931 3.488 10.773 7.94 0.004 0.005 0.013 0.004 0.018 0.008 0.007 0.027 0.021 0.053 0.026 0.08 0.255 1.007-0.816 1.819-2.155 2.438 -4.771 0.609-9.359 1.489-14.194 0.87 -9.681-1.241-9.855-5.509-10.326-6.629 -0.252-1.101-0.325-1.417-0.311-2.473 2.332-1.366 4.043-1.647 5.854-2.005C68.541 78.194 73.268 77.868 76.732 78.383z",
    fill: "url(#SvgjsRadialGradient4161)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-left",
    transform: "matrix(1,0,0,1,0.25,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4218",
    d: "M79.788 85.588c-0.869 3.192-4.162 5.073-7.361 4.196 -3.197-0.876-5.084-4.178-4.214-7.371 0.869-3.195 4.168-5.076 7.365-4.198C78.772 79.09 80.659 82.392 79.788 85.588z",
    fill: "#3c8d8e",
    stroke: "#0c5f60",
    strokeWidth: 0.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4219",
    d: "M78.855 85.662c-0.849 2.452-3.407 3.881-5.899 3.199 -2.3-0.631-3.752-2.838-3.563-5.171 0.853-0.067 1.787-0.087 2.756-0.04 -0.01 0.033-0.027 0.062-0.036 0.096 -0.306 1.125 0.407 2.305 1.592 2.63 1.189 0.326 2.401-0.326 2.707-1.451 0.039-0.147 0.06-0.294 0.065-0.439C77.29 84.782 78.088 85.165 78.855 85.662z",
    fill: "#529c9d",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4220",
    d: "M74.813 82.21c-1.203-0.344-2.429 0.342-2.739 1.54 -0.311 1.191 0.412 2.438 1.614 2.783 1.204 0.345 2.43-0.342 2.741-1.534C76.742 83.801 76.016 82.555 74.813 82.21zM75.075 86.442c-0.5 0.156-1.017-0.051-1.154-0.462 -0.133-0.411 0.163-0.867 0.667-1.019 0.503-0.156 1.019 0.051 1.157 0.459C75.881 85.831 75.582 86.287 75.075 86.442z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4221",
    d: "M70.811 87.159c-0.37 0.222-0.922 0.023-1.238-0.447 -0.316-0.466-0.269-1.024 0.102-1.247 0.368-0.219 0.925-0.021 1.239 0.446C71.226 86.378 71.181 86.938 70.811 87.159z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4222",
    d: "M78.71 83.74c-0.846 0.507-2.117 0.051-2.837-1.02 -0.72-1.072-0.612-2.352 0.234-2.857 0.844-0.509 2.118-0.053 2.834 1.019C79.66 81.954 79.556 83.232 78.71 83.74z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4185",
    d: "M55.112 83.583c3.224 11.315 7.475 23.313 17.685 23.669s22.135-7.239 22.29-22.238c0.173-16.767-10.474-23.381-20.684-23.737S50.307 66.714 55.112 83.583zM60.875 83.09c-0.252-1.101-0.325-1.417-0.311-2.473 2.027-1.21 4.04-1.547 5.851-1.905 2.123-0.418 6.853-0.845 10.317-0.329 4.587 0.679 7.931 3.488 10.773 7.94 0.004 0.005 0.013 0.004 0.018 0.008 0.007 0.027 0.021 0.053 0.026 0.08 0.255 1.007-0.816 1.819-2.155 2.438 -4.771 0.609-9.359 1.489-14.194 0.87C61.519 88.478 61.345 84.21 60.875 83.09z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4186",
    d: "M74.225 95.171c9.256 1.401 17.847-3.01 19.186-9.859 1.34-6.849-5.072-13.537-14.329-14.94 -9.258-1.399-17.845 3.012-19.185 9.862C58.557 87.082 64.967 93.766 74.225 95.171zM60.563 80.617c2.125-1.141 4.04-1.547 5.851-1.905 2.123-0.418 6.853-0.845 10.317-0.329 4.587 0.679 7.931 3.488 10.773 7.94 0.004 0.005 0.013 0.004 0.018 0.008 0.007 0.027 0.021 0.053 0.026 0.08 0.255 1.007-0.816 1.819-2.155 2.438 -4.771 0.609-9.359 1.489-14.194 0.87 -9.681-1.241-9.855-5.509-10.326-6.629C60.622 81.989 60.55 81.672 60.563 80.617z",
    fill: "url(#SvgjsRadialGradient4187)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4191",
    d: "M60.875 83.09c-0.252-1.101-0.325-1.417-0.311-2.473 2.092-1.175 4.04-1.547 5.851-1.905 2.123-0.418 6.853-0.845 10.317-0.329 4.587 0.679 7.931 3.488 10.773 7.94 0.004 0.005 0.013 0.004 0.018 0.008 0.007 0.027 0.021 0.053 0.026 0.08 0.255 1.007-0.816 1.819-2.155 2.438 -4.771 0.609-9.359 1.489-14.194 0.87C61.519 88.478 61.345 84.21 60.875 83.09z",
    fill: "url(#SvgjsRadialGradient4192)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4195",
    d: "M76.327 75.748c3.294 0.539 6.505 2.054 9.48 3.945 0.637 0.404 1.366 0.865 2.521 1.451 -0.828-0.188-1.594-0.617-2.309-1.011 0.736 0.698 1.422 1.529 1.982 2.334 -2.521-3.159-7.297-5.538-11.36-6.349 -3.902-0.779-10.989-0.264-16.251 2.042C65.208 75.449 72.237 75.08 76.327 75.748z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4196",
    d: "M87.508 86.277c-2.847-4.34-6.193-7.082-10.781-7.747 -4.833-0.705-11.271-0.221-15.034 1.843 -0.308 0.169-1.607 1.249-1.401 0.117 0.874-1.167 4.322-2.523 5.993-2.928C85.03 73.019 88.582 87.854 87.508 86.277zM60.646 82.841c-0.716 2.063 0.861 6.654 10.145 7.503 6.595 0.602 15.767-1.75 14.634-1.613 -4.779 0.589-9.375 1.449-14.219 0.839C60.224 88.19 61.468 83.023 60.646 82.841z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4168",
    d: "M122.867 78.383c-4.586 0.679-7.931 3.488-10.773 7.94 -0.004 0.005-0.012 0.004-0.018 0.008 -0.006 0.027-0.02 0.053-0.025 0.08 -0.256 1.007 0.815 1.819 2.154 2.438 4.771 0.609 9.359 1.489 14.194 0.87 9.681-1.241 9.855-5.509 10.325-6.629 0.253-1.101 0.325-1.417 0.312-2.473 -2.331-1.366-4.043-1.647-5.854-2.005C131.059 78.194 126.332 77.868 122.867 78.383z",
    fill: "url(#SvgjsRadialGradient4169)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-right",
    transform: "matrix(1,0,0,1,-0.25,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4223",
    d: "M131.788 85.588c-0.869 3.192-4.162 5.073-7.362 4.196 -3.196-0.876-5.084-4.178-4.214-7.371 0.869-3.195 4.169-5.076 7.365-4.198C130.772 79.09 132.658 82.392 131.788 85.588z",
    fill: "#3c8d8e",
    stroke: "#0c5f60",
    strokeWidth: 0.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4224",
    d: "M130.855 85.662c-0.849 2.452-3.408 3.881-5.899 3.199 -2.3-0.631-3.753-2.838-3.563-5.171 0.854-0.067 1.787-0.087 2.756-0.04 -0.01 0.033-0.027 0.062-0.036 0.096 -0.306 1.125 0.407 2.305 1.593 2.63 1.189 0.326 2.401-0.326 2.707-1.451 0.038-0.147 0.06-0.294 0.065-0.439C129.29 84.782 130.089 85.165 130.855 85.662z",
    fill: "#529c9d",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4225",
    d: "M126.813 82.21c-1.202-0.344-2.429 0.342-2.738 1.54 -0.312 1.191 0.412 2.438 1.613 2.783 1.204 0.345 2.431-0.342 2.742-1.534C128.741 83.801 128.016 82.555 126.813 82.21zM127.075 86.442c-0.5 0.156-1.018-0.051-1.154-0.462 -0.133-0.411 0.163-0.867 0.667-1.019 0.503-0.156 1.019 0.051 1.157 0.459C127.881 85.831 127.582 86.287 127.075 86.442z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4226",
    d: "M122.812 87.159c-0.37 0.222-0.923 0.023-1.238-0.447 -0.316-0.466-0.27-1.024 0.102-1.247 0.367-0.219 0.926-0.021 1.239 0.446C123.227 86.378 123.181 86.938 122.812 87.159z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4227",
    d: "M130.71 83.74c-0.846 0.507-2.116 0.051-2.837-1.02 -0.72-1.072-0.612-2.352 0.234-2.857 0.845-0.509 2.117-0.053 2.834 1.019C131.66 81.954 131.557 83.232 130.71 83.74z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4206",
    d: "M125.197 61.277c-10.211 0.356-20.857 6.97-20.685 23.737 0.154 15 12.079 22.595 22.29 22.238 10.21-0.356 16.187-17.323 17.685-23.669C148.517 66.512 135.407 60.921 125.197 61.277zM128.399 89.719c-4.835 0.619-9.423-0.261-14.194-0.87 -1.339-0.618-2.41-1.43-2.154-2.438 0.006-0.027 0.02-0.053 0.025-0.08 0.006-0.004 0.014-0.003 0.018-0.008 2.843-4.452 6.188-7.261 10.773-7.94 3.465-0.516 8.195-0.089 10.318 0.329 1.811 0.357 3.824 0.694 5.851 1.905 0.014 1.055-0.059 1.372-0.312 2.473C138.255 84.21 138.08 88.478 128.399 89.719z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4207",
    d: "M139.703 80.234c-1.34-6.85-9.928-11.261-19.186-9.862 -9.257 1.403-15.669 8.091-14.328 14.94 1.339 6.849 9.93 11.26 19.186 9.859C134.633 93.766 141.043 87.082 139.703 80.234zM138.725 83.09c-0.47 1.121-0.645 5.388-10.325 6.629 -4.835 0.619-9.423-0.261-14.194-0.87 -1.339-0.618-2.41-1.43-2.154-2.438 0.006-0.027 0.02-0.053 0.025-0.08 0.006-0.004 0.014-0.003 0.018-0.008 2.843-4.452 6.188-7.261 10.773-7.94 3.465-0.516 8.195-0.089 10.318 0.329 1.811 0.357 3.727 0.764 5.851 1.905C139.05 81.672 138.978 81.989 138.725 83.09z",
    fill: "url(#SvgjsRadialGradient4208)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4212",
    d: "M138.725 83.09c0.253-1.101 0.325-1.417 0.312-2.473 -2.092-1.175-4.04-1.547-5.851-1.905 -2.123-0.418-6.854-0.845-10.318-0.329 -4.586 0.679-7.931 3.488-10.773 7.94 -0.004 0.005-0.012 0.004-0.018 0.008 -0.006 0.027-0.02 0.053-0.025 0.08 -0.256 1.007 0.815 1.819 2.154 2.438 4.771 0.609 9.359 1.489 14.194 0.87C138.08 88.478 138.255 84.21 138.725 83.09z",
    fill: "url(#SvgjsRadialGradient4213)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4216",
    d: "M123.273 75.748c-3.295 0.539-6.506 2.054-9.48 3.945 -0.637 0.404-1.367 0.865-2.521 1.451 0.828-0.188 1.594-0.617 2.309-1.011 -0.736 0.698-1.422 1.529-1.982 2.334 2.521-3.159 7.297-5.538 11.359-6.349 3.902-0.779 10.989-0.264 16.252 2.042C134.391 75.449 127.362 75.08 123.273 75.748z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4217",
    d: "M133.314 77.563c1.672 0.405 5.119 1.761 5.994 2.928 0.205 1.132-1.094 0.052-1.402-0.117 -3.764-2.064-10.201-2.548-15.033-1.843 -4.588 0.665-7.936 3.407-10.781 7.747C111.018 87.854 114.57 73.019 133.314 77.563zM128.395 89.57c-4.844 0.61-9.439-0.25-14.219-0.839 -1.134-0.137 8.038 2.215 14.633 1.613 9.284-0.849 10.861-5.44 10.145-7.503C138.131 83.023 139.376 88.19 128.395 89.57z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-facehighlight-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2906",
    d: "M141 113.974c0.035 22.622-18.292 40.994-40.938 41.025 -22.642 0.037-41.028-18.273-41.063-40.9 -0.035-22.62 18.292-41.064 40.937-41.1C122.579 72.964 140.967 91.349 141 113.974z",
    fill: "url(#SvgjsRadialGradient2907)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2910",
    d: "M137.5 53.999c0 20.711-16.789 37.5-37.499 37.5 -20.711 0-37.501-16.789-37.501-37.5s16.79-37.5 37.501-37.5C120.711 16.499 137.5 33.288 137.5 53.999z",
    fill: "url(#SvgjsRadialGradient2911)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-rotate",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3924",
    d: "M74.799 71.28c-4.425-0.475-21.252 3.714-21.252 3.714s16.789-6.74 23.757-5.667c5.188 0.798 14.397 5.077 12.706 7.339C88.649 78.487 84.408 72.312 74.799 71.28z",
    fill: "#a68469",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-rotate",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3925",
    d: "M109.731 76.398c-1.713-2.292 7.592-6.31 13.546-6.804 7.117-0.59 22.914 4.085 22.914 4.085s-15.9-2.628-20.377-2.106C115.998 72.718 111.11 78.243 109.731 76.398z",
    fill: "#a68469",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4157",
    d: "M91.115 115.499c-0.878 2.064 5.934 4.292 8.519 4.429 2.8 0.147 10.646-2.9 9.316-4.992 -1.399-2.195-6.643-0.286-8.906-0.286C97.792 114.649 92.291 112.745 91.115 115.499z",
    fill: "#e1ac8f",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4158",
    d: "M101.857 117.058c-0.23-0.759 1.876-1.584 2.657-1.694 1.101-0.16 3.36 0.802 3.158 1.592 -0.184 0.698-2.148-0.533-2.86-0.429C104.078 116.634 102.075 117.769 101.857 117.058zM94.974 116.811c0.968 0 2.404 0.623 2.668 0.074 0.315-0.655-2.139-1.461-2.86-1.372 -0.596 0.07-2.733 1.315-2.439 1.839C92.617 117.833 93.698 116.811 94.974 116.811z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4159",
    d: "M100.089 111.999c0.607 0 1.742-0.74 1.792-2.23 0.201-6.008-0.956-23.833-1.792-23.77 -0.78 0.059-2.267 17.637-1.948 23.77C98.22 111.271 99.404 111.999 100.089 111.999z",
    fill: "#fff5ef",
    strokeWidth: "none",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beardwrap",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3042",
    d: "M100,18.13L100,18.13L100,18.13L100,18.13z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3040",
    d: "M100,18.13L100,18.13L100,18.13L100,18.13z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-front",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3682",
    d: "M45.777 90.313c-2.998-2.502-6.749-8.939-8.423-17.962 -0.356-1.849-0.61-3.75-0.88-5.763 -1.131-8.446-3.555-18.289-1.878-28.373 2.013-12.337 11.271-25.693 23.036-33.237 18.191-11.772 64.171-17.033 73.754-1.537 5.559-0.203 11.557 1.249 15.699 4.471 13.709 10.284 19.01 45.211 15.211 62.559 -2.528 11.847-3.191 14.954-8.264 19.599 1.812-54.323-0.99-39.665-3.306-54.253 -2.715-1.99-3.727-1.168-7.909-3.542 -8.318-6.142-7.915-8.602-11.683-12.898 -3.356 3.969-8.181 7.463-11.907 9.077 0.944-1.547 1.749-3.282 2.282-4.398l-0.446-0.373c-3.129 2.262-9.451 5.478-13.336 5.823 2.087-2.565 1.843-2.242 2.677-3.805 -3.116 1.916-6.427 3.217-10.604 3.583 3.935-1.944 5.699-3.274 8.751-5.817l-0.279-0.518c-21.191 6.437-26.218 7.895-41.755 10.651 -13.012 1.627-8.248 0.252-12.968 0.252 -7.593 0-8.798 22.789-8.47 30.387C45.925 85.479 44.837 81.343 45.777 90.313z",
    fill: "#b84131",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3683",
    d: "M162.296 70.471c-2.528 11.847-3.191 14.954-8.264 19.599 1.812-54.323-0.99-39.665-3.306-54.253 -2.715-1.99-3.727-1.168-7.909-3.542 -8.318-6.142-7.915-8.602-11.683-12.898 -3.356 3.969-8.181 7.463-11.907 9.077 0.944-1.547 1.749-3.282 2.282-4.398l-0.446-0.373c-3.129 2.262-9.451 5.478-13.336 5.823 2.087-2.565 1.843-2.242 2.677-3.805 -3.116 1.916-6.427 3.217-10.604 3.583 3.935-1.944 5.699-3.274 8.751-5.817l-0.279-0.518c-21.191 6.437-26.218 7.895-41.755 10.651 -13.012 1.627-8.248 0.252-12.968 0.252 -7.593 0-8.798 22.789-8.47 30.387 0.846 21.241-0.242 17.104 0.698 26.075 -2.998-2.502-6.749-8.939-8.423-17.962 -0.356-1.849-0.61-3.75-0.88-5.763 -1.131-8.446-3.555-18.289-1.878-28.373 1.59-9.746 13.727-24.08 22.024-31.729 -25.5 23.75-18 50.252-13.75 71.5C41.619 59.235 38 29 55 28c23 0 48.869-3.265 64.869-19.265C118.869 15.735 118 17 113 22c4-3 9-5 11-10 -1 4-1 7-4 10 3-2 6-5 9-8 0 3-2 6-3 9 2-5 8-8 9-13 -3 13 12.369 19.985 17.119 22.735 6.5 9 6.75 28 5.25 43.75 5.5-18 3-48.75-13.25-70C161.869 19.485 165.6 55.386 162.296 70.471zM60.369 19.985c12.207-0.359 21.165-2.337 34.25-9.75C82.032 15.751 74.067 18.383 60.369 19.985zM93.619 15.735c6.46-2.681 10.955-8.497 18.25-10.25C105.146 7.818 100.471 13.67 93.619 15.735zM54.869 19.485c4.629-8.324 14.52-15.222 27-16.25C71.713 5.123 60.837 10.953 54.869 19.485z",
    fill: "#a92d1c",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3684",
    d: "M86.619 0c13.085-5.594 24.996-5.023 37.5 1.985 -13.123-5.605-23.154-4.532-23.154-4.532C98.577-2.36 94.759-2.452 86.619 0zM138.119 7.985c4.139 1.594 5.866 4.016 8.383 7.511 3.685 5.954 4.716 8.533 6.863 14.489C151.28 21.431 146.603 10.292 138.119 7.985zM114.619 7.735c-7.115 6.003-12.274 9.237-26.5 14C99.361 19.065 106.526 15.916 114.619 7.735zM137.619 13.985c2.067 7.036 5.876 10.957 11.75 14.5C143.909 24.378 140.339 20.566 137.619 13.985zM58.619 10.235c0 0-0.486 0.36-1.287 0.952 -9.145 6.479-16.294 18.86-16.463 34.548C42.864 30.127 49.049 19.143 58.619 10.235zM63.369 14.735c7.757-4.055 11.339-4.087 24.25-6.25C76.476 9.262 70.964 9.793 63.369 14.735zM84.417 18.964c-4.565 2.29-15.277 4.855-15.277 4.74 -3.757 0.834-10.27 2.281-10.27 2.281 2.522-0.319 6.849-0.825 10.418-1.591 0 0.135 8.796-1.985 11.379-3.319 2.836-1.338 1.875-0.813 4.703-2.59C85.369 18.485 85.008 18.667 84.417 18.964z",
    fill: "#c75849",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3685",
    d: "M147.27 7.675c-4.229-3.289-10.323-4.741-15.721-4.54 -4.611-7.454-19.151-9.598-27.97-9.69 -13.304-0.138-34.324 3.653-46.11 11.28 -10.968 7.032-21.023 20.286-23.17 33.44 -1.284 7.721-0.178 15.721 1.13 23.38 0.64 3.7 0.97 7.43 1.63 10.86 1.897 10.227 6.295 16.626 9.09 18.57 -1.065-9.855 0.097-4.998-0.77-26.75 -0.403-9.331 1.305-30.714 8.49-30.06 4.883 0.345 1.014 1.191 12.7-0.271 15.347-2.722 20.366-4.152 41.79-10.659 -3.357 2.798-5.103 4.068-9.6 6.22 -0.01-0.01-0.01 0-0.01 0 -0.14 0.07-0.29 0.14-0.43 0.2 3.719-0.024 8.346-1.305 11.299-3.12 -0.407 0.762-1.632 2.147-2.539 3.3 3.844 0 10.74-3.438 14.16-5.91 -0.48 1-1.603 3.462-2.811 5.21 1.141-0.57 3.874-1.313 9.33-5.93 1.11-0.93 2.38-2.19 3.38-3.37 3.349 3.818 3.148 6.516 11.53 12.7 4.158 2.36 5.282 1.625 7.78 3.45 2.206 14.448 5.134-0.795 3.26 54.78 5.6-4.96 6.275-8.026 8.88-20.23C166.297 53.602 161.249 18.163 147.27 7.675zM160.949 70.325c-2.216 12.286-2.402 14.36-6.88 19.22 0.814-10.8 1.53-20.459 1.319-31.34 -0.444-16.061-2.58-13.048-4.1-22.72 -2.878-2.021-4.273-1.655-6.92-2.85 -0.46-0.17-0.84-0.46-1.27-0.68 -8.392-5.824-8.398-8.604-11.83-12.27 0.971-1.114 1.813-2.391 2.09-2.94 -1.509 2.264-7.977 8.239-14.11 11.63 1.059-1.676 1.864-3.305 2.44-4.78 1.735-1.212 2.92-2.358 3.92-3.35 -3.419 2.84-12.225 7.96-17.75 9.07 0.174-0.179 1.875-1.826 2.516-3.074 1.355-0.542 5.016-2.779 6.304-4.203 -6.304 4.203-13.475 6.72-15.979 7.136 3.064-1.149 7.04-4.731 9.08-6.36 1.971-1.574 2.353-2.206 4.399-4.28 -1.344 0.938-3.44 2.993-6.056 4.097 -1.547 0.653-43.89 12.498-51.254 10.574 -1.478-0.37-3.149-0.818-4.62-0.39 -11.8 5.076-7.461 37.634-7.3 47.63 0.136 8.423 0.74 9.89 0.74 9.89 -7.751-7.36-8.089-23.554-8.9-29.18 -1.028-7.456-1.923-15.371-0.55-22.77 2.24-12.64 11.912-25.407 22.26-32.06 15.469-10.04 61.594-18.533 73.04-2.83C159.954 3.495 163.94 50.271 160.949 70.325z",
    fill: "#8a1000",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3926",
    d: "M148.02 85.54c-0.11 1.96-0.35 4.05-0.59 6.25 -1.04 9.74-5.26 12.49-24.57 11.1 -6.3-0.45-11.06-4.04-13.41-10.1 -0.99-2.55-1.87-5.52-2.37-8.48C116.7 77.81 139.4 77.62 148.02 85.54zM51.98 85.54c0.11 1.96 0.35 4.05 0.59 6.25 1.04 9.74 5.26 12.49 24.57 11.1 6.3-0.45 11.06-4.04 13.41-10.1 0.99-2.55 1.87-5.52 2.37-8.48C83.3 77.81 60.6 77.62 51.98 85.54z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3927",
    d: "M148.02 85.54c-8.62-7.92-31.33-7.73-40.93-1.23 -0.36-2.11-0.52-4.22-0.36-6.16h0c0.66-7.81 13.45-6.88 20.98-7.17C146.33 70.26 148.56 76.34 148.02 85.54zM93.27 78.14L93.27 78.14c-0.66-7.81-13.45-6.88-20.99-7.17 -18.61-0.71-20.85 5.37-20.31 14.56 8.62-7.92 31.33-7.73 40.93-1.23C93.26 82.19 93.43 80.09 93.27 78.14z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3928",
    d: "M149.91 75.08c-0.62-1.42-1.48-2.7-2.56-3.65 -2.47-2.16-7.08-2.46-11.39-2.71 -4.19-0.23-12.15-0.42-17.46-0.08 -13.8 0.9-13.57 7-13.57 7 -1.81 0-8.03 0-9.84 0 0 0 0.23-6.11-13.57-7 -5.32-0.34-13.27-0.16-17.46 0.08 -4.31 0.24-8.93 0.55-11.39 2.71 -1.09 0.95-1.94 2.22-2.56 3.65l-8.19-1.58v3.99c7.17 1.38 9.02 1.82 10.02 1.76 -0.25 3.01-0.36 8.35 0.29 12.59 1.54 10.07 5.78 12.78 24.94 11.4 6.36-0.46 11.35-4.23 13.72-10.33 1.86-4.8 3.14-9.09 2.81-14.28h12.64c-0.33 5.19 0.95 9.49 2.81 14.28 2.36 6.1 7.36 9.87 13.72 10.33 19.17 1.38 23.41-1.33 24.94-11.4 0.65-4.24 0.54-9.58 0.29-12.59 1 0.06 2.85-0.38 10.02-1.76V73.5L149.91 75.08zM90.07 92.61c-2.27 5.87-6.88 9.35-12.98 9.78 -19.08 1.37-22.61-1.33-24.04-10.68 -0.76-5.01-0.35-11.52-0.25-12.52 0.19-0.03 0.31-0.06 0.32-0.1 1.09-6.36 6.45-8.42 29.02-7.35 3.73 0.18 6.92 0.88 8.69 2.75 1.04 1.09 2.04 2.66 1.95 4.17l0.04 0C93.02 81.2 92.44 86.5 90.07 92.61zM146.94 91.72c-1.43 9.35-4.96 12.05-24.04 10.68 -6.1-0.44-10.71-3.92-12.98-9.78 -2.37-6.11-2.94-11.41-2.74-13.95l0.04 0c-0.09-1.5 0.91-3.07 1.95-4.17 1.77-1.87 4.96-2.57 8.69-2.75 22.57-1.06 27.92 0.99 29.02 7.35 0.01 0.04 0.13 0.08 0.32 0.1C147.29 80.2 147.71 86.71 146.94 91.72z",
    fill: "#092e0c",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3929",
    d: "M104.94 75.34c0.17-1.26 1.63-5.92 13.54-6.69 5.32-0.34 13.27-0.16 17.46 0.08 4.31 0.24 8.93 0.55 11.39 2.71 1.09 0.95 1.94 2.22 2.56 3.65l0 0c-3.72-6.16-10.22-5.54-14.01-5.75 -2.3-0.13-6.21-0.27-10.28-0.27 -2.77 0-5.15 0.06-7.06 0.19C111.48 69.71 107.56 70.92 104.94 75.34zM95.06 75.34c-0.17-1.26-1.63-5.92-13.54-6.69 -5.32-0.34-13.27-0.16-17.46 0.08 -4.31 0.24-8.93 0.55-11.39 2.71 -1.09 0.95-1.94 2.22-2.56 3.65l0 0c3.72-6.16 10.22-5.54 14.01-5.75 2.3-0.13 6.21-0.27 10.28-0.27 2.77 0 5.15 0.06 7.06 0.19C88.52 69.71 92.44 70.92 95.06 75.34z",
    fill: "#123d16",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "SvgjsRect1057",
    width: 200,
    height: 15,
    x: 0,
    y: 185,
    fill: "#ecf0f1",
    opacity: 0.5,
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "SvgjsText1058",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontSize: "10px",
    textAnchor: "start",
    fontWeight: 400,
    anchor: "start",
    fill: "#333333",
    x: 38.749820709228516,
    y: 182.42831206321716,
    style: {
      display: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "SvgjsTspan1059",
    dy: 13,
    x: 38.749820709228516
  }, "Created on svgAvatars.com")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDAvatar);
export default __webpack_public_path__ + "static/media/d-avatar.6f3dbce25cc6bb3f53697772d256ac54.svg";
export { ForwardRef as ReactComponent };